<style scoped lang="scss">

</style>

<template>
  <select-input expanded="expanded" :label="label" ref="stateSelect" :error="error" v-model="modelValue">
    <option v-for="(state, stateId) in states" :value="stateId" :key="stateId">{{ state }}</option>
  </select-input>
</template>

<script>
import SelectInput from "@/Shared/SelectInput";
import {v4 as uuid} from "uuid";

export default {
  name: "StateSelect",
  components: {SelectInput},
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    error: String,
    expanded: Boolean,
    label: {
      type: String,
      default: 'State',
    },
    value: {
      required: true,
    },
  },
  computed: {
    modelValue: {
      get() { return this.value },
      set(newValue) {
        // console.log('setting new value', newValue);
        this.$emit('input', newValue);
      },
    },
  },
  data() {
    return {
      selected: this.modelValue,
      states: {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      },
    }
  },
  watch: {
    selected(selected) {
      this.$refs.stateSelect.selected = selected;
      this.$emit('update:modelValue', selected)
    },
  },

}
</script>
